// document.addEventListener('DOMContentLoaded', () => {
//   const isAdminPreview = window.location.href.includes('admin.shopify.com') || (window.Shopify && Shopify.designMode);
//   const urlParams = new URLSearchParams(window.location.search);
//   const hasFilterTag = urlParams.has('filter.p.tag');
//   const pathSegments = window.location.pathname.split('/');
//   const isFilteredByPath = pathSegments.length > 3 && pathSegments[2] === 'decorte';

//   const sections = document.querySelectorAll('.c_decorte-campaign, .c_decorte-products, .c_decorte-newArrivals, .c_decorte-counseling, .c_decorte-ranking, .c_decorte-heading, .c_decorte-top, .c_decorte-story');

//   sections.forEach((section) => {
//     if (isAdminPreview) {
//       if (hasFilterTag || isFilteredByPath) {
//         section.style.display = 'none';
//       } else {
//         section.style.display = 'block';
//       }
//     } else {
//       if (hasFilterTag || isFilteredByPath) {
//         section.style.display = 'none';
//       } else {
//         section.style.display = 'block';
//       }
//     }
//   });
// });


document.addEventListener('DOMContentLoaded', () => {
  const isAdminPreview = window.location.href.includes('admin.shopify.com') || (window.Shopify && Shopify.designMode);
  const urlParams = new URLSearchParams(window.location.search);
  const hasFilterTag = urlParams.has('filter.p.tag');
  const hasSortBy = urlParams.has('sort_by');
  const pathSegments = window.location.pathname.split('/');
  const isFilteredByPath = pathSegments.length > 3 && pathSegments[2] === 'decorte';

  const collectionSection = document.querySelector('.c_main-collection'); // 商品グリッドセクションのクラスを指定
  const sections = document.querySelectorAll(
    '.c_decorte-campaign, .c_decorte-products, .c_decorte-newArrivals, .c_decorte-counseling, .c_decorte-ranking, .c_decorte-heading, .c_decorte-top, .c_decorte-story, .c_new-arrivals, .c_cpb-closeup, .c_cpb-top, .brandtop_intro_wrapper, .c_cpb-heading, .c_cpb-brandtop-id, .c_cpb-brandtop-category'
  );

  // 商品グリッドセクションの表示/非表示制御
  if (collectionSection) {
    if (hasFilterTag || isFilteredByPath || hasSortBy) {
      collectionSection.style.display = 'block'; // フィルタリング時に表示
    } else {
      collectionSection.style.display = 'none'; // デフォルトは非表示
    }
  }

  // 他のセクションの表示/非表示制御（既存のロジック）
  sections.forEach((section) => {
    if (isAdminPreview) {
      if (hasFilterTag || isFilteredByPath || hasSortBy) {
        section.style.display = 'none';
      } else {
        section.style.display = 'block';
      }
    } else {
      if (hasFilterTag || isFilteredByPath || hasSortBy) {
        section.style.display = 'none';
      } else {
        section.style.display = 'block';
      }
    }
  });
});
